document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll("[data-bh-reels-slider]");

  sliders.forEach(function (slider) {
    const track = slider.querySelector(".bh-reels-track");
    const cards = slider.querySelectorAll(".bh-reel-card");
    const leftArrow = slider.querySelector(".bh-reels-arrow--left");
    const rightArrow = slider.querySelector(".bh-reels-arrow--right");

    if (!track || cards.length === 0) return;

    let index = 0;
    let autoTimer = null;
    let autoActive = true;

    function visibleCount() {
      return window.innerWidth <= 768 ? 2 : 4;
    }

    function gapSize() {
      return 15;
    }

    function step() {
      return cards[0].offsetWidth + gapSize();
    }

    function maxIndex() {
      return Math.max(cards.length - visibleCount(), 0);
    }

    function update() {
      if (index > maxIndex()) index = 0;

      track.style.transform = "translateX(-" + index * step() + "px)";

      cards.forEach(function (card, i) {
        card.classList.toggle("is-active", i === index + 1);
      });
    }

    function next() {
      index++;

      if (index > maxIndex()) {
        index = 0;
      }

      update();
    }

    function prev() {
      index = Math.max(index - 1, 0);
      update();
    }

    function stopAutoTimerOnly() {
      if (autoTimer) {
        clearInterval(autoTimer);
        autoTimer = null;
      }
    }

    function stopAuto() {
      autoActive = false;
      stopAutoTimerOnly();
    }

    function startAuto() {
      stopAutoTimerOnly();

      autoTimer = setInterval(function () {
        if (!autoActive) return;
        next();
      }, 4800);
    }

    if (leftArrow) {
      leftArrow.addEventListener("click", function () {
        stopAuto();
        prev();
      });
    }

    if (rightArrow) {
      rightArrow.addEventListener("click", function () {
        stopAuto();
        next();
      });
    }

    let startX = 0;
    let dragging = false;

    track.addEventListener("mousedown", function (e) {
      stopAuto();
      dragging = true;
      startX = e.pageX;
    });

    document.addEventListener("mouseup", function () {
      dragging = false;
    });

    document.addEventListener("mousemove", function (e) {
      if (!dragging) return;

      const diff = e.pageX - startX;

      if (diff > 60) {
        prev();
        dragging = false;
      }

      if (diff < -60) {
        next();
        dragging = false;
      }
    });

    let touchStart = 0;

    track.addEventListener("touchstart", function (e) {
      stopAuto();
      touchStart = e.touches[0].clientX;
    }, { passive: true });

    track.addEventListener("touchend", function (e) {
      const diff = e.changedTouches[0].clientX - touchStart;

      if (diff > 50) {
        prev();
      } else if (diff < -50) {
        next();
      }
    });

    window.addEventListener("resize", update);

    update();
    startAuto();
  });
});